import { endpoints } from "@app/api/apis";
import ROUTE from "@app/navigationApp/routes";
import Button from "@app/sharedComponents/Button/Button";
import { useAppSelector } from "@app/store/hooks";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import { WarningCircle } from '@sharedComponents/Icons/Icons';
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { ScrollView } from "react-native";

const routes = {
    PRINCIPAL_REPAYMENT: ROUTE.FLEXI_PAY,
    IN_APP_INTEREST_COLLECTION: ROUTE.INTEREST_PAYMENT,
    SHORTFALL_REPAYMENT: ROUTE.SHORTFALL_REPAY,
    FORECLOSURE:ROUTE.HOW_TO_CLOSE_ACCOUNT
}

const CarouselActionCards = ({navigation }) => {
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const [failedRequestDetails, setFailedRequestDetails] = useState({});
    
    const fetchFailedRequests = () =>{
        const url = endpoints.failedRequests + userDetails?.linkedCredits[0]?.creditId       
        axios.get(url).then((res)=>{
          setFailedRequestDetails(res?.data)
        }).catch((err)=>{
          console.log('fetchFailedRequests',err);
        })
      }

    useEffect(()=>{
    if(userDetails?.linkedApplications[0]?.accountId && userDetails?.linkedCredits[0]?.creditId ){
        fetchFailedRequests()
    }
    },[userDetails])
    const { collectionDetailsList, disbursalDetailsList } = failedRequestDetails || {};
    const totalCards = (collectionDetailsList?.length || 0) + (disbursalDetailsList?.length || 0);


    const renderCollectionFailedCard = (collectionDetails,index) => (
        <ThemedView
            backgroundColor="bg-fill-primary"
            borderRadius="sm"
            p="sm"
            width={totalCards === 1 ? "100%" :'75%'}
            borderWidth={1}
            borderColor="border-primary"
            mr="sm"
        >
                <ThemedView flexDirection="row" alignItems="center"  justifyContent="space-between" >
                    <ThemedView flexDirection="row" alignItems="center" mr="lg">
                        <WarningCircle weight="fill" size={24} color={themeColorSet["icon-error"]} />
                        <ThemedView ml="sm">
                            <ThemedText variant="b4s" color="text-primary">Repayment failed</ThemedText>
                            <ThemedText variant="b5r" color="text-secondary">₹{formatIndianCurrency(collectionDetails?.actualAmountCollected)} • {dayjs(collectionDetails?.createdOn).format('DD MMM, hh:mm A')}</ThemedText>
                        </ThemedView>
                    </ThemedView>
                    <ThemedView flexDirection="row"  alignItems="center" justifyContent="flex-end" >
                        <Button type="TEXT" size="SM" label="Details" handlePress={() => navigation.navigate(ROUTE.TRANSACTION_SCREEN,{transactionId:collectionDetails?.collectionId})} overRideTextStyle={{marginHorizontal:0}}/>
                        <Button type="OUTLINED" size="SM" label="Retry" handlePress={()=>navigation.navigate(routes[collectionDetails?.collectionType],{paymentAmount:collectionDetails?.actualAmountCollected})} overRideTextStyle={{marginHorizontal:0}} overRideStyle={{marginLeft:8}}  />
                    </ThemedView>
                </ThemedView>
        </ThemedView>
    );

    const renderDisbursalFailedCard = (disbursalDetail, index) => (
        <ThemedView
            backgroundColor="bg-fill-primary"
            borderRadius="sm"
            p="sm"
            width={totalCards === 1 ? "100%" :'75%'}
            borderWidth={1}
            borderColor="border-primary"
            mr="sm"
        >
                <ThemedView flexDirection="row" alignItems="center"  justifyContent="space-between" >
                    <ThemedView flexDirection="row" alignItems="center" mr="lg">
                        <WarningCircle weight="fill" size={24} color={themeColorSet["icon-error"]} />
                        <ThemedView ml="sm">
                            <ThemedText variant="b4s" color="text-primary">Withdrawal failed                            </ThemedText>
                            <ThemedText variant="b5r" color="text-secondary">₹{formatIndianCurrency(disbursalDetail?.amount)} • {dayjs(disbursalDetail?.createdOn).format('DD MMM, hh:mm A')}</ThemedText>
                        </ThemedView>
                    </ThemedView>
                    <ThemedView flexDirection="row"  alignItems="center" justifyContent="flex-end" >
                        <Button type="TEXT" size="SM" label="Details" handlePress={() => navigation.navigate(ROUTE.TRANSACTION_SCREEN)} overRideTextStyle={{marginHorizontal:0}} />
                        <Button type="OUTLINED" size="SM" label="Retry" handlePress={()=>{navigation.navigate(ROUTE.WITHDRAW_AMOUNT,{amount:disbursalDetail?.amount})}} overRideTextStyle={{marginHorizontal:0}} overRideStyle={{marginLeft:8}} />
                    </ThemedView>
                </ThemedView>
        </ThemedView>
    );
    if(totalCards===0) return null;
    return (
        <>
            <ThemedView mt="lg" ml="lg" mr="sm" flex={1}>
                {totalCards > 1 ? (
                    <ScrollView contentContainerStyle={{flex:1}}  horizontal showsHorizontalScrollIndicator={false}>
                        {collectionDetailsList?.length > 0 && collectionDetailsList?.map(renderCollectionFailedCard)}
                        {disbursalDetailsList?.length > 0 && disbursalDetailsList?.map(renderDisbursalFailedCard)}
                    </ScrollView>
                ) : (
                    <ThemedView>
                        {collectionDetailsList?.length > 0 && collectionDetailsList?.map(renderCollectionFailedCard)}
                        {disbursalDetailsList?.length > 0 && disbursalDetailsList.map(renderDisbursalFailedCard)}
                    </ThemedView>
                )}
            </ThemedView>
        </>
    );
};

export default CarouselActionCards;